import { SpendingReportState } from '../interface/MyInterfaces'

export default function (state: SpendingReportState = { }, action) {
    let propertyName: string;

    switch (action.type) {
        case "OPEN_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CLOSE_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_REPORT_LOADING":
            return action.payload;
        case "SPENDING_TAB1_HEADER":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].header = action.payload.header;
            newState[propertyName].sub_header = action.payload.sub_header;
            newState[propertyName].report_text = action.payload.report_text;
            newState[propertyName].chart1_main_title = action.payload.chart1_main_title;
            newState[propertyName].chart2_main_title = action.payload.chart2_main_title;
            newState[propertyName].chart3_main_title = action.payload.chart3_main_title;
            newState[propertyName].chart4_main_title = action.payload.chart4_main_title;
            newState[propertyName].chart1_chart_title = action.payload.chart1_chart_title;
            //newState[propertyName].chart1_chart_title_agg = action.payload.chart1_chart_title_agg;

            newState[propertyName].chart2_chart_title = action.payload.chart2_chart_title;
            //newState[propertyName].chart2_chart_title_agg = action.payload.chart2_chart_title_agg;

            newState[propertyName].chart3_chart_title = action.payload.chart3_chart_title;
            return newState;

        case "SPENDING_TAB1_CHART1":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].chart1_text = action.payload.chart1_text;
            return newState;

            case "SPENDING_TAB1_CHART1_DATA":
            propertyName = "SpendingEmployeeChart_Data";
            var newState = Object.assign({}, state);
            newState[propertyName]= action.payload;
            return newState;

        case "SPENDING_TAB1_CHART1_YEARS":
            propertyName = "SpendingEmployeeChart_Years";
            var newState = Object.assign({}, state);
            newState[propertyName]= action.payload;
            return newState;

        case "SPENDING_TAB1_CHART2":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].chart2_text = action.payload.chart2_text;
            return newState;
        case "SPENDING_TAB1_CHART2_DATA":
            propertyName = "SpendingEmployeeAgencyChart_Data";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SPENDING_TAB1_CHART3":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].chart3_text = action.payload.chart3_text;
            return newState;
    
        case "SPENDING_TAB1_CHART4":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].chart4_text = action.payload.chart4_text;
            newState[propertyName].chart4_chart_title = action.payload.chart4_chart_title;
            return newState;

        case "SPENDING_TAB1_FOOTER":
            propertyName = "SpendingReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].footer_text = action.payload;
            return newState;

        case "SPENDING_TAB2_FOOTER":
            propertyName = "SpendingReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].footer_text = action.payload;
            newState["SpendingReport_Tab3"].footer_text = action.payload;

            return newState;

            

        case "SPENDING_TAB2_HEADER":
            propertyName = "SpendingReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].header = action.payload.header;
            newState[propertyName].sub_header = action.payload.sub_header;
            newState[propertyName].chart1_chart_title = action.payload.chart1_chart_title;
            
            newState[propertyName].chart2_chart_title = action.payload.chart2_chart_title;
            return newState;

        case "SPENDING_TAB2_CHART1":
            propertyName = "SpendingReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].chart1_text = action.payload.chart1_text;
            newState[propertyName].chart2_text = action.payload.chart2_text;
            return newState;



        case "SPENDING_TAB3_HEADER":
            propertyName = "SpendingReport_Tab3";
            var newState = Object.assign({}, state);
            newState[propertyName].header = action.payload.header;
            newState[propertyName].sub_header = action.payload.sub_header;
            newState[propertyName].university = action.payload.university;
            newState[propertyName].Initial_the_university = action.payload.Initial_the_university;
            newState[propertyName].bench_year = action.payload.bench_year;

            newState[propertyName].bench_schools = action.payload.bench_schools;
            return newState;


        case "SPENDING_TAB4_HEADER":
            propertyName = "SpendingReport_Tab4";
            var newState = Object.assign({}, state);
            newState[propertyName].header = action.payload.header;
            newState[propertyName].rangeLabel = action.payload.rangeLabel;
            newState[propertyName].methodology_text = action.payload.methodology_text;
            newState[propertyName].description = action.payload.description;
            newState[propertyName].change_description = action.payload.change_description;
            
            return newState;

        case "SPENDING_AGGTAB_HEADER":
            propertyName = "SpendingReport_AggTab";
            var newState = Object.assign({}, state);
            newState[propertyName].header = action.payload.header;
            newState[propertyName].sub_header = action.payload.sub_header;
            newState[propertyName].report_text = action.payload.report_text;
            newState[propertyName].chart1_main_title = action.payload.chart1_main_title;

            newState[propertyName].chart1_chart_title = action.payload.chart1_chart_title;
            newState[propertyName].chart2_chart_title = action.payload.chart2_chart_title;
            newState[propertyName].chart3_chart_title = action.payload.chart3_chart_title;
            return newState;

        case "SPENDING_AGGTAB_CHART1_DATA":
            propertyName = "SpendingEmployeeChart_Data_Agg";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SPENDING_AGGTAB_CHART1_YEARS":
            propertyName = "SpendingEmployeeChart_Years_Agg";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;


        case "SPENDING_AGGTAB_CHART2_DATA":
            propertyName = "SpendingEmployeeAgencyChart_Data_Agg";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SPENDING_AGGTAB_CHART1":
            propertyName = "SpendingReport_AggTab";
            var newState = Object.assign({}, state);
            newState[propertyName].chart1_text = action.payload.chart1_text;
            return newState;


        case "SPENDING_AGGTAB_CHART2":
            propertyName = "SpendingReport_AggTab";
            var newState = Object.assign({}, state);
            newState[propertyName].chart2_text = action.payload.chart2_text;
            return newState;


        case "SPENDING_AGGTAB_CHART3":
            propertyName = "SpendingReport_AggTab";
            var newState = Object.assign({}, state);
            newState[propertyName].chart3_text = action.payload.chart3_text;
            return newState;


        case "US_STATES":
            propertyName = "USStateList";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "JOB_CLASSIFICATION":
            propertyName = "SpendingJobClassification";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_BASIC_INFO_LOADING":
            propertyName = "SpendingReportConf";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EMPLOYEE_CHART":
            propertyName = "SpendingEmployeeChart";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EMPLOYEE_AGENCY_CHART":
            propertyName = "SpendingEmployeeAgencyChart";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EXPENDITURE_MAP":
            propertyName = "SpendingExpenditureMap";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_TOTAL_BY_FIPS":
            propertyName = "SpendingTotalByFips";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_CONGRESS_MAP":
            propertyName = "SpendingCongressMap";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SPENDING_EMPLOYEE_TABLE":
            propertyName = "SpendingEmployeeTable";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EMPLOYEE_AGENCY_TABLE":
            propertyName = "SpendingEmployeeAgencyTable";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EXPENDITURE_TABLE":
            propertyName = "SpendingExpenditureTable";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EXPENDITURE_TABLE2":
            propertyName = "SpendingExpenditureTable2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_INSTATE_EXPENDITURE_BOXPLOT":
            propertyName = "SpendingInStateExpenditureBoxPlot";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_SUMMARY_TABLE":
            propertyName = "SpendingSummaryTable";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_RELEASE":
            propertyName = "spendingRelease";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "TOP_8_CSV":
            propertyName = "Top8CSV";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "SPENDING_EMPLOYEE_CHART_AGGREGATE":
            propertyName = "SpendingEmployeeChart_Aggregate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EMPLOYEE_AGENCY_CHART_AGGREGATE":
            propertyName = "SpendingEmployeeAgencyChart_Aggregate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_EXPENDITURE_MAP_AGGREGATE":
            propertyName = "SpendingExpenditureMap_Aggregate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "SPENDING_TOTAL_BY_FIPS_AGGREGATE":
            propertyName = "SpendingTotalByFips_Aggregate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "DOWNLOAD":
            return state;
        default:
            return state;
    }
}
